import { z } from 'zod';
import { SUB_ACCOUNT_CONSTRAINTS } from '@/lib/constants/account';

/**
 * Form values use GB for storage/transfer (converted to bytes at submit boundary).
 * Null represents "unlimited" (no limit set).
 */
export const subAccountCreateSchema = z.object({
  label: z.string()
    .trim()
    .min(1, 'Label is required')
    .max(SUB_ACCOUNT_CONSTRAINTS.LABEL_MAX, `Cannot exceed ${SUB_ACCOUNT_CONSTRAINTS.LABEL_MAX} characters`),
  storageLimitGB: z.number().min(0, 'Must be 0 or greater').nullable(),
  transferLimitGB: z.number().min(0, 'Must be 0 or greater').nullable(),
  appCfgLimit: z.number().int().min(0, 'Must be 0 or greater'),
  allowDvr: z.boolean().nullable(),
  videostreamLimit: z.number().int().min(0, 'Must be 0 or greater').nullable(),
  // App platform toggles
  allowWeb: z.boolean(),
  allowAndroid: z.boolean(),
  allowIos: z.boolean(),
  allowRoku: z.boolean(),
  allowAppletv: z.boolean(),
  allowFiretv: z.boolean(),
  allowAndroidtv: z.boolean(),
});

export type SubAccountCreateFormValues = z.infer<typeof subAccountCreateSchema>;

export const subAccountEditSchema = subAccountCreateSchema.extend({
  isActive: z.boolean(),
});

export type SubAccountEditFormValues = z.infer<typeof subAccountEditSchema>;
